// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__39e94","productName":"Table_productName__1_KKf"};